import { AnalogInput } from 'z3k-config';
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
export function getClimaticSensorsConfig(sensors) {
    const shared_sensors = sensors.map((sensor) => {
        if (!sensor) {
            return null;
        }
        const { sensor_key } = sensor;
        if (sensor_key === Z3kSecondRoutes.analog_inputs) {
            const has_external_thermostat = AnalogInput.Type.THERMOSTAT === sensor.type;
            if (has_external_thermostat) {
                return null;
            }
        }
        return sensor;
    });
    return shared_sensors;
}
